import Layout from '../../internal/Layout.vue'
import index from './index.vue'

const CriticalityMatrixRoutes = {
  component: Layout,
  children: [
    {
      name: 'criticalityMatrix',
      path: '/',
      component: index,
      meta: {
        requiresAuth: true,
        requiresPredial: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
  ],
}

export default CriticalityMatrixRoutes
